<template>
  <div
    v-if="announcements.length"
    class="grid-container announcements-container"
  >
    <h3>Announcements</h3>
    <modal
      v-for="announcement in announcements"
      :key="'modal' + announcement.id"
      class="announcement-modal"
      :name="'modal-' + announcement.id"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <button
        class="hide-modal-btn"
        @click="$modal.hide('modal-' + announcement.id)"
      >
        <i class="fal fa-times" />
      </button>
      <div>
        <h3 v-html="announcement.title.rendered" />
      </div>
      <div>
        <p v-html="announcement.content.rendered" />
      </div>
      <div>
        <span>
          Announced on: {{ announcement.date }} |
        </span>
        <span>Posted by: </span>
        <a
          v-for="category in announcement.categories_list"
          :key="category.id"
          :href="'departments/' + category.slug"
        >
          <span>{{ category.name }} </span>
        </a>
      </div>
    </modal>
    <div
      v-for="announcement in announcements"
      :key="announcement.id"
      class="card card--announcement pam"
      tabindex="0"
      @click="$modal.show('modal-' + announcement.id)"
    >
      <div class="grid-x">
        <div class="cell pbs ">
          <i
            class="fas fa-bullhorn "
            aria-hidden="true"
          /> <span>Announcement</span>
        </div>
        <div class="cell  ">
          <header class="">
            <h4 v-html="announcement.title.rendered" />
          </header>
        </div>
        <div class="cell">
          <span class="date-published">{{ announcement.date }}</span>
        </div>
      </div>
    </div>
    <div class=" announcements-button pbl">
      <a
        class="button float-right content-type-featured mbxl"
        href="/the-latest/#announcements"
        aria-label="See all announcements"
      >
        See all announcements
        <i
          class="fas fa-angle-right fa-lg"
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VModal from "vue-js-modal";
import Vue from "vue";
Vue.use(VModal);

const announcementsEndpoint = process.env.VUE_APP_ANNOUNCEMENTS_API_URL;
const categoriesEndpoint = process.env.VUE_APP_CATEGORIES_API_URL;

export default {
  data() {
    return {
      announcements: [],
      allAnnouncements: [],
      categories: [],
    };
  },
  computed: {},
  mounted: async function () {
    let vm = this;
    await vm.getCategories();
    await vm.getAnnouncements();
  },
  methods: {

    async getCategories() {
      let vm = this;
      try {
        const response = await axios.get(categoriesEndpoint);
        vm.categories = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async getAnnouncements() {
      let vm = this;
      try {
        const response = await axios.get(announcementsEndpoint, {
          params: {
            per_page: 100,
            page: 1,
            _fields: "id,date,link,title,categories,tags,meta_box,content",
          },
        });

        response.data.forEach((announcement) => {
          announcement.date = vm.convertDate(announcement.date);
          announcement.categories_list = vm.convertCategories(announcement.categories);
          announcement.showAnnouncement =
            vm.showAnnouncement(announcement.meta_box.phila_announce_end_date) &&
            announcement.meta_box.show_on_home == "1";
          if (announcement.showAnnouncement) {
            vm.announcements.push(announcement);
          }
        });

        vm.allAnnouncements = response.data;
      } catch (error) {
        console.error(error);
      }
    },


    //converts date from UTC to MMMM DD, YYYY
    convertDate(UTCDate) {
      let date = new Date(UTCDate);
      let month = date.toLocaleString("default", { month: "long" });
      let day = date.getDate();
      let year = date.getFullYear();
      let formattedDate = month + " " + day + ", " + year;
      return formattedDate;
    },

    //converts date from unix number to MMM DD, YYYY
    convertUnixdate(UNIXDate) {
      let tempDate = Number(UNIXDate) + 18000;
      let date = new Date(tempDate * 1000);
      let month = date.toLocaleString("default", { month: "short" });
      let day = date.getDate();
      let year = date.getFullYear();
      let formattedDate = month + " " + day + ", " + year;
      return formattedDate;
    },

    showAnnouncement(unixDate) {
      //if unix date is before current date, return false
      let currentDate = new Date();
      let announcementDate = new Date(unixDate * 1000);
      // console.log(announcementDate);
      return currentDate < announcementDate;
    },

    convertCategories(categories) {
      let categoryList = [];
      //loop through the categories array and fetch the category name based on id
      categories.forEach((category) => {
        let categoryObj = this.categories.find((cat) => cat.id === category);
        //only add the commas if there are more than one category
        categoryList.push(categoryObj);
      });
      return categoryList;
    },
  },
};
</script>

<style lang="scss">
.announcements-container {
  margin-bottom: 32px;
}

.card.card--announcement {
  background: #f0f0f0;
  border-bottom: 5px solid #2176d2;
  margin-bottom: 32px;
  cursor: pointer;

  &:hover {
    opacity: .6;
    transition: opacity .2s ease-in-out;
  }
}

.announcement-modal {
  .vm--modal {
    padding: 20px;
    border-bottom: 5px #2176d2 solid;
    border-top: 5px solid #2176d2;
    height: auto !important;
    z-index: 999;
    // cursor: default;
  }

  .hide-modal-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0;
    font-size: 20px;
    background-color: #fff;
    opacity: .8;
    z-index: 999;
    cursor: pointer;

    &:hover {
      color: #444;
    }
  }
}
</style>